import { FieldConfig } from '../../api/contract-notice-dto';

export function evalDescriptionNormalizer(
  fieldConfig: FieldConfig,
  model: any
): void {
  const itemsTableHead = fieldConfig?.jsonField;
  const itemSort = fieldConfig?.jsonFieldSort;
  const fieldFiltered = model?.[itemsTableHead];

  if (itemsTableHead && itemSort) {

    if (fieldFiltered?.description) {
      model[itemSort] = fieldFiltered?.description;
    } else if (fieldFiltered?.name) {
      model[itemSort] = fieldFiltered?.name;
    } else if (Array.isArray(model?.listaLotes)) {
      model[itemSort] = model?.listaLotes
        ?.map((item) => item.description)
        ?.join(', ');
    } else if (model.description) {
      model[itemSort] = fieldFiltered
    }
  }
}

